import { createErrorClass } from '@canvas/error';

/**
 * Thrown during development mode if a flyweight is used outside the tick it was
 * filled with values.
 */
export const FlyweightPoolStaleReferenceError = createErrorClass(
  'FlyweightPoolStaleReferenceError'
);
